/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TarifDto } from './TarifDto';
import {
    TarifDtoFromJSON,
    TarifDtoFromJSONTyped,
    TarifDtoToJSON,
    TarifDtoToJSONTyped,
} from './TarifDto';
import type { TypePrelevement } from './TypePrelevement';
import {
    TypePrelevementFromJSON,
    TypePrelevementFromJSONTyped,
    TypePrelevementToJSON,
    TypePrelevementToJSONTyped,
} from './TypePrelevement';
import type { TypeEcheance } from './TypeEcheance';
import {
    TypeEcheanceFromJSON,
    TypeEcheanceFromJSONTyped,
    TypeEcheanceToJSON,
    TypeEcheanceToJSONTyped,
} from './TypeEcheance';
import type { TypeCommission } from './TypeCommission';
import {
    TypeCommissionFromJSON,
    TypeCommissionFromJSONTyped,
    TypeCommissionToJSON,
    TypeCommissionToJSONTyped,
} from './TypeCommission';

/**
 * Détail d'un frais du tunnel, alimente le formulaire d'édition.
 * @export
 * @interface FraisTunnelDetailDto
 */
export interface FraisTunnelDetailDto {
    /**
     * 
     * @type {string}
     * @memberof FraisTunnelDetailDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FraisTunnelDetailDto
     */
    tunnelId?: string;
    /**
     * 
     * @type {string}
     * @memberof FraisTunnelDetailDto
     */
    natureRemunerationId?: string;
    /**
     * 
     * @type {string}
     * @memberof FraisTunnelDetailDto
     */
    natureRemunerationLibelle?: string | null;
    /**
     * 
     * @type {TarifDto}
     * @memberof FraisTunnelDetailDto
     */
    tarif?: TarifDto;
    /**
     * 
     * @type {string}
     * @memberof FraisTunnelDetailDto
     */
    compteBancaireId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FraisTunnelDetailDto
     */
    beneficiairePersonneId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FraisTunnelDetailDto
     */
    beneficiaireNom?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FraisTunnelDetailDto
     */
    isCourtierConnecte?: boolean;
    /**
     * 
     * @type {TypePrelevement}
     * @memberof FraisTunnelDetailDto
     */
    typePrelevement?: TypePrelevement;
    /**
     * 
     * @type {TypeEcheance}
     * @memberof FraisTunnelDetailDto
     */
    typeEcheance?: TypeEcheance;
    /**
     * 
     * @type {Array<string>}
     * @memberof FraisTunnelDetailDto
     */
    garantiesExclues?: Array<string> | null;
    /**
     * 
     * @type {TarifDto}
     * @memberof FraisTunnelDetailDto
     */
    taxe?: TarifDto;
    /**
     * 
     * @type {TypeCommission}
     * @memberof FraisTunnelDetailDto
     */
    typeCommission?: TypeCommission;
    /**
     * 
     * @type {number}
     * @memberof FraisTunnelDetailDto
     */
    minimum?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FraisTunnelDetailDto
     */
    maximum?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FraisTunnelDetailDto
     */
    _default?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof FraisTunnelDetailDto
     */
    valeurs?: Array<number> | null;
    /**
     * Affichage du frais sur la page de tarification.
     * @type {boolean}
     * @memberof FraisTunnelDetailDto
     */
    displayedOnPricing?: boolean;
}



/**
 * Check if a given object implements the FraisTunnelDetailDto interface.
 */
export function instanceOfFraisTunnelDetailDto(value: object): value is FraisTunnelDetailDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function FraisTunnelDetailDtoFromJSON(json: any): FraisTunnelDetailDto {
    return FraisTunnelDetailDtoFromJSONTyped(json, false);
}

export function FraisTunnelDetailDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FraisTunnelDetailDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'tunnelId': json['tunnelId'] == null ? undefined : json['tunnelId'],
        'natureRemunerationId': json['natureRemunerationId'] == null ? undefined : json['natureRemunerationId'],
        'natureRemunerationLibelle': json['natureRemunerationLibelle'] == null ? undefined : json['natureRemunerationLibelle'],
        'tarif': json['tarif'] == null ? undefined : TarifDtoFromJSON(json['tarif']),
        'compteBancaireId': json['compteBancaireId'] == null ? undefined : json['compteBancaireId'],
        'beneficiairePersonneId': json['beneficiairePersonneId'] == null ? undefined : json['beneficiairePersonneId'],
        'beneficiaireNom': json['beneficiaireNom'] == null ? undefined : json['beneficiaireNom'],
        'isCourtierConnecte': json['isCourtierConnecte'] == null ? undefined : json['isCourtierConnecte'],
        'typePrelevement': json['typePrelevement'] == null ? undefined : TypePrelevementFromJSON(json['typePrelevement']),
        'typeEcheance': json['typeEcheance'] == null ? undefined : TypeEcheanceFromJSON(json['typeEcheance']),
        'garantiesExclues': json['garantiesExclues'] == null ? undefined : json['garantiesExclues'],
        'taxe': json['taxe'] == null ? undefined : TarifDtoFromJSON(json['taxe']),
        'typeCommission': json['typeCommission'] == null ? undefined : TypeCommissionFromJSON(json['typeCommission']),
        'minimum': json['minimum'] == null ? undefined : json['minimum'],
        'maximum': json['maximum'] == null ? undefined : json['maximum'],
        '_default': json['default'] == null ? undefined : json['default'],
        'valeurs': json['valeurs'] == null ? undefined : json['valeurs'],
        'displayedOnPricing': json['displayedOnPricing'] == null ? undefined : json['displayedOnPricing'],
    };
}

export function FraisTunnelDetailDtoToJSON(json: any): FraisTunnelDetailDto {
    return FraisTunnelDetailDtoToJSONTyped(json, false);
}

export function FraisTunnelDetailDtoToJSONTyped(value?: FraisTunnelDetailDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tunnelId': value['tunnelId'],
        'natureRemunerationId': value['natureRemunerationId'],
        'natureRemunerationLibelle': value['natureRemunerationLibelle'],
        'tarif': TarifDtoToJSON(value['tarif']),
        'compteBancaireId': value['compteBancaireId'],
        'beneficiairePersonneId': value['beneficiairePersonneId'],
        'beneficiaireNom': value['beneficiaireNom'],
        'isCourtierConnecte': value['isCourtierConnecte'],
        'typePrelevement': TypePrelevementToJSON(value['typePrelevement']),
        'typeEcheance': TypeEcheanceToJSON(value['typeEcheance']),
        'garantiesExclues': value['garantiesExclues'],
        'taxe': TarifDtoToJSON(value['taxe']),
        'typeCommission': TypeCommissionToJSON(value['typeCommission']),
        'minimum': value['minimum'],
        'maximum': value['maximum'],
        'default': value['_default'],
        'valeurs': value['valeurs'],
        'displayedOnPricing': value['displayedOnPricing'],
    };
}

